import { useEffect } from 'react';

declare function Genesys(
  command: string,
  action: string,
  options: Record<string, any>,
  onSuccess?: (response: any) => void,
  onError?: (error: any) => void
): void;

interface GenesysChatProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function GenesysChat({ isOpen, onClose }: GenesysChatProps) {
  useEffect(() => {
    if (typeof Genesys !== 'function') return;
    if (isOpen) {
      Genesys(
        'command',
        'Messenger.open',
        {},
        function (o) {}, // if resolved
        function (o) {
          // if rejected
          Genesys('command', 'Messenger.close', {});
          onClose();
        }
      );
    } else {
      Genesys('command', 'Messenger.close', {});
    }
  }, [isOpen, onClose]);

  return null; // Genesys handles its own UI
}
